// src/pages/AdminDashboard.jsx
import React from "react";
import AdminPanel from "./AdminPanel";

export default function AdminDashboard() {
  // `AdminPanel` is a full-page layout (MenuBar/HeaderBar/main). Don't nest it inside another layout.
  return <AdminPanel />;
}
